export const DAY_WINDOWS: readonly number[] = [1, 7, 30, 90];
